import { render, staticRenderFns } from "./SettingMain.vue?vue&type=template&id=c720aaa6&scoped=true&"
import script from "./SettingMain.vue?vue&type=script&lang=js&"
export * from "./SettingMain.vue?vue&type=script&lang=js&"
import style0 from "./SettingMain.vue?vue&type=style&index=0&id=c720aaa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c720aaa6",
  null
  
)

export default component.exports